import { NgModule } from '@angular/core';
import { FormFieldModule } from '@sb/library/form-field';
import { RecaptchaComponent } from './recaptcha.component';
import { UtilityModule } from "@sb/library/utility";
import { NgxCaptchaModule } from 'ngx-captcha';

@NgModule({
    declarations: [
        RecaptchaComponent
    ],
    imports: [
        FormFieldModule,
        UtilityModule,
        NgxCaptchaModule
    ],
    exports: [
        RecaptchaComponent
    ],
})
export class RecaptchaModule { }
